import React from "react";
import NavHome from "../../component/atom/Icon/SVG/NavHome";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../config/router/router.config";

export type OrganizationRouteParam = DefaultRouteParam;

export const organizationRoute: RouteConfig = {
  name: "Organization",
  Component: React.lazy(() => import("./Organization.view")),
  path: "/organization",
  isPrivate: true,

  options: {
    icon: <NavHome />,
    label: "Organization",
    testID: "MenuOrganization",
  },
};
